import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import installElementPlus from './plugins/element'
import './styles/main.scss'
import '@babel/polyfill'
import 'ts-replace-all'

const app = createApp(App)
installElementPlus(app)
app.use(store).use(router).mount('#app')
